import { render, staticRenderFns } from "./Inventory-Management.vue?vue&type=template&id=009d8652&scoped=true&"
import script from "./Inventory-Management.vue?vue&type=script&lang=js&"
export * from "./Inventory-Management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009d8652",
  null
  
)

export default component.exports